import ListErrors from '../components/ListErrors'
import React from 'react'
import agent from '../agent'
import { store } from '../store'
import { push } from 'react-router-redux'
import { connect } from 'react-redux'
import {
    GET_PIN_CODE,
    LOGIN_PAGE_VERIFY_PIN_CODE,
    VERIFY_PIN_CODE_UNLOADED,
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.auth,
    inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
    onGetPinCode: (payload, userKey, phone) => {
        dispatch({ type: GET_PIN_CODE, payload, userKey, phone })
    },
    onCheckPinCode: (payload, userKey, phone) => {
        dispatch({ type: LOGIN_PAGE_VERIFY_PIN_CODE, payload, userKey, phone })
    },
    onUnload: () =>
        dispatch({ type: VERIFY_PIN_CODE_UNLOADED })
})

class Verification extends React.Component {
    constructor() {
        super()
        this.state = {
            userKey: null,
            phone: null,
            code: ''
        }
        this.updateState = field => ev => {
            const state = this.state;
            const newState = Object.assign({}, state, { [field]: ev.target.value });
            this.setState(newState);
        }
        this.checkPinCode = (code) => ev => {
            ev.preventDefault()
            const payload = agent.Auth.verifyPinCode(this.state.userKey, code, 'login');
            this.props.onCheckPinCode(payload)
        }
    }
    componentWillMount(props) {
        if (this.props.userKey) {
            Object.assign(this.state, {
                userKey: this.props.userKey,
                phone: this.props.phone,
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo) {
            store.dispatch(push(nextProps.redirectTo))
            this.props.onRedirect()
        }
    }
    componentWillUnmount() {
        this.props.onUnload()
    }

    render() {
        const code = this.state.code || ''
        return (
            <div id="focus">
                <div id="main">
                    <div id="main-wrap">
                        <div id="focus-wrap">
                            <h2>Verification Code</h2>
                            <div className="FormItem">
                                <label>code</label>
                                <input type="text" value={code} onChange={this.updateState('code')} />
                            </div>
                            <ListErrors errors={this.props.errors} />
                            <div className="FormItem">
                                <button onClick={this.checkPinCode(code)}>{this.props.inProgress ? 'Login...' : 'Login'}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Verification)
